module.exports = __webpack_public_path__ + "img/icon-internet-home-aqua.3c27ddc5.svg";